import React from 'react';
import ReactDOM from 'react-dom';
import cn from 'classnames';
import styles from './Tooltip.module.css';

const Tooltip = ({ text, position }) => {
    return ReactDOM.createPortal(
        <div
            className={cn(styles.tooltip)}
            style={{
                position: 'fixed',
                top: position.y,
                left: position.x,
                transform: 'translate(-50%, -100%)',
                zIndex: 1000,
            }}
        >
            {text}
        </div>,
        document.body
    );
};

export default Tooltip;
